import { c as _c } from "react/compiler-runtime";
import { useJwtToken } from "@website/hooks/auth-manager";
import { useViewPort } from "@website/hooks/viewport";
import { useLoginModal } from "@website/widget/login";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const useReverseBookingModal = () => {
  const $ = _c(12);
  const router = useRouter();
  const {
    onLoginModalOpen
  } = useLoginModal();
  const {
    isDesktop
  } = useViewPort();
  const {
    phoneNumber
  } = useJwtToken();
  const [isReservePageOpen, setIsReservePageOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsReservePageOpen(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onModalClose = t0;
  let t1;
  if ($[1] !== onLoginModalOpen || $[2] !== phoneNumber || $[3] !== router?.query?.date_from || $[4] !== router?.query?.date_to) {
    t1 = () => {
      setIsReservePageOpen(true);
      if (!phoneNumber && router?.query?.date_from && router?.query?.date_to) {
        return onLoginModalOpen().then(() => setIsReservePageOpen(true));
      }
    };
    $[1] = onLoginModalOpen;
    $[2] = phoneNumber;
    $[3] = router?.query?.date_from;
    $[4] = router?.query?.date_to;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onModalOpen = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsReservePageOpen(false);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isDesktop) {
    t3 = [isDesktop];
    $[7] = isDesktop;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== isReservePageOpen || $[10] !== onModalOpen) {
    t4 = {
      isReservePageOpen,
      onModalClose,
      onModalOpen
    };
    $[9] = isReservePageOpen;
    $[10] = onModalOpen;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};